module.exports = __webpack_public_path__ + "img/google_play_logo.9480ce31.png";